import React, {Component} from 'react';
import { reduxForm, Field } from 'redux-form'
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux'
import { Link } from 'react-router'
import { PropTypes } from 'prop-types';
import ReactLoading from "react-loading";
import {
  CardHeader, CardTitle, Row, Label, 
  Col, Card, CardBody, 
  Button, Input, InputGroup, InputGroupAddon, 
  InputGroupText, FormGroup, CardImg,
} from 'reactstrap';

import Messages from '../../../notifications/Messages'
import Errors from '../../../notifications/Errors'
import {LoginField} from '../../../views/controls/_FieldValication'
import { validate2FARegister } from '../../../lib/validation'

// Import actions
import {twoFASettingRequest, twoFASettingPosting} from './actions';
import {
  TWO_FA_REQUEST_SUCCESS,
} from './constants'

class TwoFASetting extends Component {
  // Pass the correct proptypes in for validation
  static propTypes = {
    handleSubmit: PropTypes.func,
    twoFASettingRequest: PropTypes.func.isRequired, // <-- new
    twoFASettingPosting: PropTypes.func.isRequired, // <-- new
    twoFASetting: PropTypes.shape({
      data: PropTypes.object,
      requesting: PropTypes.bool,
      successful: PropTypes.bool,
      messages: PropTypes.array,
      errors: PropTypes.array,
    })
  }
 
  constructor(props) {
    super(props);
    this.state = {
      cancel: false,
      data: {}
    };

    this.toggleCancel = this.toggleCancel.bind(this);
    this.initData()
  }

  initData = () => {
    const { twoFASettingRequest } = this.props
    return twoFASettingRequest()
  }

  submit = (values) => {
    const { twoFASettingPosting } = this.props
    
    return twoFASettingPosting(values)
  }

  toggleCancel() {
    this.props.history.push('/myaccount');
  }
  
  componentWillReceiveProps(nextProps){
    if (nextProps.twoFASetting.type == TWO_FA_REQUEST_SUCCESS){
      let { data } = this.state
      data = nextProps.twoFASetting.data
      this.setState({data});
    }
  }

  render() {
    const {  
      handleSubmit, // remember, Redux Form injects this into our props
      twoFASetting: {
        requesting,
        messages,
        errors,
      },
    } = this.props

    const {data} = this.state;
    let text_submit = 'Enable';
    if (data && data.active2fa){
      text_submit = 'Disable';
    }
    return (
      <div className="animated fadeIn">
          <Row className="justify-content-center">
            <Col md="12">
                <Card>
                  <CardHeader>
                    <i className="fa fa-key"></i>Two Factor Authentication
                  </CardHeader>
                  <CardBody className="card-body">
                    <Row>
                      <Col md="8">
                        <Row>
                          <Col md="12">
                            <Label>
                            To enable Two Factor Authentication you must download an Authenticator Application and to add Duoc you can use the code below or scan the QR code. Then the application will provide a 6 digit code which you will need to login.
                            </Label>
                          </Col>
                        </Row>
                        <form className="widget-form" method="post" onSubmit={handleSubmit(this.submit)}>
                          <FormGroup row>
                            <Col md="4" className="wallet-address">
                              <Field icon="icon-lock" type="number" name="mfa_code" placeholder="Enter token 2fa code" component={LoginField} className="text form-control"/>
                            </Col>
                          </FormGroup>
                          <Row>
                            <Col md="12">
                              {requesting && (
                                <ReactLoading type="bubbles" color="#84c752" />
                              )}
                              {!requesting && !!errors.length && (
                                <Errors message="Failure to signup due to:" errors={errors} />
                              )}
                              {!requesting && !!messages.length && (
                                <Messages messages={messages} />
                              )}  
                            </Col>
                          </Row>
                          <Row>
                            <Col xs="12">
                              <Button color="primary" className="btn btn-brand" action="submit">{text_submit}</Button>
                              &nbsp;
                              <Button color="secondary" className="btn btn-brand" onClick={this.toggleCancel}>Cancel</Button>
                            </Col>
                          </Row>
                        </form>
                      </Col>
                      {!data.active2fa ? (
                        <Col md="4">
                          <div className="qr_code">
                              <img style={{with:'200px'}} src={data.google_qr_uri} alt="Card image cap" />
                          </div>
                        </Col>
                      ) : null}
                    </Row>
                  </CardBody>
                </Card>
            </Col>
          </Row>
      </div>
    );
  }
}

// Grab only the piece of state we need
const mapStateToProps = state => ({
  twoFASetting: state.twoFASetting,
})

// make Redux state piece of `login` and our action `loginRequest`
// available in this.props within our component
const connected = connect(mapStateToProps, { twoFASettingRequest, twoFASettingPosting })(TwoFASetting)

// in our Redux's state, this form will be available in 'form.login'
const formed = reduxForm({
  form: 'twoFASetting',
  validate: validate2FARegister,
})(connected)

export default formed;



// WEBPACK FOOTER //
// ./src/views/Pages/TwoFASetting/TwoFASetting.js